import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'Moonlight Finance - (BSC)',
  description:
    'Earn MOFI  through yield farming ',
  image: 'https://exchange.moonlight.finance/images/swapimg/twitter.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  switch (path) {
    case '/':
      return {
        title: `${t('Home')} | ${t('Moonlight Finance')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('Moonlight Finance')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('Moonlight Finance')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('Moonlight Finance')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('Moonlight Finance')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('Moonlight Finance')}`,
      }
    case '/collectibles':
      return {
        title: `${t('Collectibles')} | ${t('Moonlight Finance')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('Moonlight Finance')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('Moonlight Finance')}`,
      }
    case '/profile/tasks':
      return {
        title: `${t('Task Center')} | ${t('Moonlight Finance')}`,
      }
    case '/profile':
      return {
        title: `${t('Your Profile')} | ${t('Moonlight Finance')}`,
      }
    default:
      return null
  }
}
